// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 1.4;
}

.project-status-badge.status-active {
  background-color: #e6f4ea;
  color: #28a745;
}

.project-status-badge.status-inactive {
  background-color: #f8d7da;
  color: #dc3545;
}

.project-status-badge.status-completed {
  background-color: #cff4fc;
  color: #0dcaf0;
}

.project-status-badge.status-archived {
  background-color: #f8d7da;
  color: #dc3545;
}

.project-status-badge.status-draft {
  background-color: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

.project-status-badge.status-unknown {
  background-color: #f1f3f5;
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ProjectStatusBadge.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".project-status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.project-status-badge.status-active {\n  background-color: #e6f4ea;\n  color: #28a745;\n}\n\n.project-status-badge.status-inactive {\n  background-color: #f8d7da;\n  color: #dc3545;\n}\n\n.project-status-badge.status-completed {\n  background-color: #cff4fc;\n  color: #0dcaf0;\n}\n\n.project-status-badge.status-archived {\n  background-color: #f8d7da;\n  color: #dc3545;\n}\n\n.project-status-badge.status-draft {\n  background-color: rgba(108, 117, 125, 0.1);\n  color: #6c757d;\n}\n\n.project-status-badge.status-unknown {\n  background-color: #f1f3f5;\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
